module.exports = __webpack_public_path__ + "img/csv-format.e1e65c42.svg";